import {
  CloudCred,
  TenantType,
} from "@buf/brevdev_devplane.bufbuild_es/devplaneapi/v1/cloud_cred_pb";
import type {
  GPUInstanceType,
  InstanceCloudCred,
} from "types/InstanceTypes";

export const isActiveCloudCred = (cloudCred: CloudCred) =>
  !!cloudCred.cloudCredId && cloudCred.status !== "inactive";

export const isSharedCloudCred = (cloudCred: CloudCred) =>
  cloudCred.tenantType === TenantType.SHARED;

export const isIsolatedCloudCred = (cloudCred: CloudCred) =>
  cloudCred.tenantType === TenantType.ISOLATED;

export const cloudCredMatchesId = (
  cloudCred: CloudCred,
  id: string | undefined,
) => !!id && cloudCred.cloudCredId === id;

export const getCloudCredForEnvironment = (
  cloudCredId: string | undefined,
  cloudCreds: CloudCred[],
) => cloudCreds.find((cloudCred) => cloudCredMatchesId(cloudCred, cloudCredId));

export const getInstanceCloudCreds = (
  instanceType: GPUInstanceType | undefined | null,
): InstanceCloudCred[] =>
  instanceType?.cloud_creds ?? [];

export const getPrimaryInstanceCloudCred = (
  instanceType: GPUInstanceType | undefined | null,
) => getInstanceCloudCreds(instanceType)[0];

export const getPrimaryInstanceCloudCredId = (
  instanceType: GPUInstanceType | undefined | null,
) =>
  getPrimaryInstanceCloudCred(instanceType)?.id ||
  instanceType?.cloud_cred_id ||
  (instanceType as any)?.cloudCredId ||
  instanceType?.cloud_cred?.cloud_cred_id ||
  (instanceType?.cloud_cred as any)?.cloudCredId;

export const isLaunchpadInstance = (
  instanceType: GPUInstanceType | undefined | null,
): boolean =>
  getInstanceCloudCreds(instanceType).some(
    (cloudCred) => cloudCred.platformType?.toLowerCase() === "launchpad",
  );
